import { useEffect, useRef, useState } from "react";
import { Camera, FileUp, FileText, CheckCircle2 } from "lucide-react";

const ACCEPT = "image/jpeg,image/png,image/webp,image/heic,image/heif,application/pdf";

const Thumb = ({ preview, file, existing, label }) => {
  if (preview) return <img src={preview} alt={label} />;
  if (file) return <FileText size={22} />;
  if (existing) return <CheckCircle2 size={22} />;
  return <Camera size={22} />;
};

const statusText = (file, existing, hint) => {
  if (file) return file.name;
  if (existing) return `Tersimpan: ${existing}`;
  return hint;
};

export const AttachmentField = ({ kind, label, hint, file, existing, onChange }) => {
  const cameraRef = useRef(null);
  const fileRef = useRef(null);
  const [preview, setPreview] = useState("");
  useEffect(() => {
    if (!file || !file.type.startsWith("image/")) { setPreview(""); return undefined; }
    const url = URL.createObjectURL(file); setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);
  const pick = (e) => { const f = e.target.files?.[0]; if (f) onChange(f); e.target.value = ""; };
  return <div className={`attach-field ${file || existing ? "filled" : ""}`} data-testid={`attach-${kind}`}>
    <div className="attach-thumb"><Thumb preview={preview} file={file} existing={existing} label={label} /></div>
    <div className="attach-body">
      <strong>{label} <span className="req">*</span></strong>
      <span className="muted">{statusText(file, existing, hint)}</span>
      <div className="attach-actions">
        <button type="button" data-testid={`attach-${kind}-camera`} className="attach-btn primary" onClick={() => cameraRef.current?.click()}><Camera size={15} /> {file || existing ? "Foto ulang" : "Buka kamera"}</button>
        <button type="button" data-testid={`attach-${kind}-file`} className="attach-btn" onClick={() => fileRef.current?.click()}><FileUp size={15} /> Pilih file / PDF</button>
      </div>
    </div>
    <input ref={cameraRef} data-testid={`attach-${kind}-camera-input`} type="file" accept="image/*" capture="environment" hidden onChange={pick} />
    <input ref={fileRef} data-testid={`attach-${kind}-file-input`} type="file" accept={ACCEPT} hidden onChange={pick} />
  </div>;
};
